var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSensorPropertiesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sensor",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Sensor .cls-1 {\n        fill: #7826ff;\n      }\n\n      #Sensor .cls-2 {\n        fill: #fff;\n      }\n\n      #Sensor .cls-3 {\n        filter: url(#Ellipse_537);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_537",
    x: 0,
    y: 0,
    width: 54,
    height: 54,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_537-2",
    "data-name": "Ellipse 537",
    className: "cls-1",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2369",
    "data-name": "Pfad 2369",
    className: "cls-2",
    d: "M15.512,15.653s-4.722,6.752-4.722,9.39a4.723,4.723,0,1,0,9.445,0c0-2.638-4.722-9.39-4.722-9.39m3.315,9.061a1.214,1.214,0,1,1-1.213-1.228,1.22,1.22,0,0,1,1.213,1.228m.584-11.11a1.038,1.038,0,0,1-.734-.3,4.583,4.583,0,0,0-6.331,0,1.038,1.038,0,0,1-1.468-1.468,6.55,6.55,0,0,1,9.267,0,1.038,1.038,0,0,1-.734,1.772m2.924-2.924a1.043,1.043,0,0,1-.734-.3,8.622,8.622,0,0,0-12.18,0A1.038,1.038,0,1,1,7.953,8.908a10.7,10.7,0,0,1,15.116,0,1.038,1.038,0,0,1-.734,1.772M25.26,7.755a1.039,1.039,0,0,1-.734-.3,12.759,12.759,0,0,0-18.029,0A1.038,1.038,0,0,1,5.028,5.984a14.841,14.841,0,0,1,20.966,0,1.036,1.036,0,0,1-.734,1.77",
    transform: "translate(2.488 1.004)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorPropertiesIcon);
export default __webpack_public_path__ + "static/media/sensor-properties-icon.96f2bf3c6c26ca6a5a65d95597d09bd1.svg";
export { ForwardRef as ReactComponent };